import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageES() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addES(data) {
    return privateFetch.post(`/v1/admin/es`, data);
  }

  function updateES({ id: esID, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/es/${esID}`, rest);
  }

  function manageES(data) {
    if (data.id) return updateES(data);

    return addES(data);
  }

  return useMutation(manageES, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('ES');
    },
  });
}

export default useManageES;
